<template>
  <!-- A movable key light. Everything you draw is described by where the
       light is; this page keeps a light source in the room with you. -->
  <div class="spot" aria-hidden="true" :style="style"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const style = ref({ transform: 'translate3d(-50%,-50%,0) translate3d(50vw, 30vh, 0)' })
let raf = 0
let tx = 0.5
let ty = 0.3
let cx = 0.5
let cy = 0.3

function onMove(e) {
  tx = e.clientX / window.innerWidth
  ty = e.clientY / window.innerHeight
}

function loop() {
  cx += (tx - cx) * 0.08
  cy += (ty - cy) * 0.08
  style.value = {
    transform: `translate3d(-50%,-50%,0) translate3d(${(cx * 100).toFixed(2)}vw, ${(cy * 100).toFixed(2)}vh, 0)`
  }
  raf = requestAnimationFrame(loop)
}

onMounted(() => {
  window.addEventListener('pointermove', onMove, { passive: true })
  raf = requestAnimationFrame(loop)
})
onUnmounted(() => {
  window.removeEventListener('pointermove', onMove)
  cancelAnimationFrame(raf)
})
</script>

<style scoped>
.spot {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 46vw;
  height: 46vw;
  min-width: 380px;
  min-height: 380px;
  pointer-events: none;
  background: radial-gradient(
    closest-side,
    rgba(255, 208, 150, 0.075),
    rgba(255, 180, 92, 0.03) 45%,
    transparent 72%
  );
  will-change: transform;
}
</style>
